/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlusOutlined } from '@ant-design/icons'
import Dragger from 'antd/es/upload/Dragger'
import {
  requestCheckEmailInSystem,
  requestCheckEmailInUehApi,
} from 'app/api/newTumRegister'
import {
  initValuesFormCreateTum,
  ITradeUnionMember,
} from 'app/api/tradeUnionMembers/model'
import R from 'app/assets/R'
import { SvgPictureIcon } from 'app/assets/svg-assets'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { Loading } from 'app/components/common/Loading'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { notificationController } from 'app/controllers/notification-controller'
import { useReviewTum } from 'app/react-query/hook/newTumRegister'
import { isEmpty, omit } from 'lodash'
import { moment, ResponseType } from 'parkway-web-common'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { uploadMultipleFiles } from 'app/service/general/service'
import dayjs from 'dayjs'
import {
  FormTumCommon,
  IFormCreateTradeUnionMember,
} from 'app/containers/TradeUnionMemberManagement/components/hook'
import { PositionEnum } from 'app/containers/TradeUnionMemberManagement/type'

export const ReviewTumModal = () => {
  const { t } = useTranslation()
  const modalRef = useRef<IRefModal>({})
  const [form] = BaseForm.useForm<IFormCreateTradeUnionMember>()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [fileName, setFileName] = useState<string | undefined>(undefined)
  const [fileUpload, setFile] = useState<File | undefined>(undefined)
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
  // Xử lý sau khi upload thành công
  const handleUploadChange = (info: any) => {
    const file = info?.file
    if (file) {
      const url = URL.createObjectURL(file)
      setFileName(file?.name)
      form.setFieldsValue({ file: url })
      setFile(file)
    }
  }
  const { mutateAsync, isLoading } = useReviewTum()

  const handleOpen = () => {
    modalRef.current?.open?.()
  }

  const handleSubmit = async (values: IFormCreateTradeUnionMember) => {
    setIsLoadingSubmit(true)
    try {
      if (!fileUpload) return
      const files = await uploadMultipleFiles([fileUpload])

      if (!files?.length) return

      const res = await mutateAsync({
        ...omit(values, 'image'),
        chucVucongdoan: (values?.chucVucongdoan as unknown as string[]).join(
          ',',
        ),
        ngaySinh: values?.ngaySinh?.format('DD/MM/YYYY'),
        ngayVaoUEH: values?.ngayVaoUEH?.format('DD/MM/YYYY'),
        ngayVaoCongDoan: values?.ngayVaoCongDoan?.format('DD/MM/YYYY'),
        file: files?.[0]?.url,
        fileName: files?.[0]?.name,
      })

      if (res) {
        modalRef.current?.hide?.()
        form?.resetFields()
        notificationController.success({
          message: 'Khai báo đoàn viên thành công',
        })
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setIsLoadingSubmit(false)
    }
  }

  const handleValidateEmail = async () => {
    try {
      if (!isEmpty(email)) {
        const res: ResponseType<ITradeUnionMember> =
          await requestCheckEmailInSystem({ email })
        if (res?.data) {
          form.setFields([
            {
              name: 'email',
              errors: ['Email đã tồn tại'],
            },
          ])
        } else {
          const res: ResponseType<ITradeUnionMember> =
            await requestCheckEmailInUehApi({ email })
          if (res?.data) {
            form.setFieldsValue({
              fullName: res?.data?.fullName,
              dienThoaiDiDong: res?.data.dienThoaiDiDong,
              gioiTinh: res?.data.gioiTinh,
              nguyenQuan: res?.data.nguyenQuan,
              cmnd: res?.data.cmnd,
              tenDonVi: res?.data.tenDonVi,
              tinhTrangLamViec: res?.data.tinhTrangLamViec,
              danToc: res?.data.danToc,
              tonGiao: res?.data.tonGiao,
              noiOHienNay: res?.data.noiOHienNay,
              hocHam: res?.data.hocHam,
              hocVi: res?.data.hocVi,
              soTheDoanVien: res?.data.soTheDoanVien,
              tinhTrangSinhHoat: res?.data.tinhTrangSinhHoat,
              tenPhanHieu: res?.data.tenPhanHieu,
              chucVucongdoan: [res?.data.chucVucongdoan ?? PositionEnum.DoanVien] as any,
              email: res?.data.email,
              mql: res?.data.mql,
              unitId: res?.data.unit?.id,
              ngaySinh: (!isEmpty(res?.data?.ngaySinh)
                ? dayjs(moment(res?.data?.ngaySinh, 'DD/MM/YYYY').toDate())
                : undefined) as any,
              ngayVaoUEH: !isEmpty(res?.data?.ngayVaoUEH)
                ? dayjs(moment(res?.data?.ngayVaoUEH, 'DD/MM/YYYY').toDate())
                : (undefined as any),
              ngayVaoCongDoan: !isEmpty(res?.data?.ngayVaoCongDoan)
                ? dayjs(
                    moment(res?.data?.ngayVaoCongDoan, 'DD/MM/YYYY').toDate(),
                  )
                : (undefined as any),
            })
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const timer = setTimeout(async () => {
      handleValidateEmail()
    }, 500)
    return () => clearTimeout(timer)
  }, [email])
  const reset = () => {
    setEmail('')
    form?.resetFields()
  }

  return (
    <BaseModalComponent
      titleModal="Khai báo đoàn viên"
      handleSubmit={form?.submit}
      buttonOpenModal={
        <BaseButton
          icon={<PlusOutlined rev={undefined} />}
          onClick={handleOpen}
        >
          {'Khai báo đoàn viên'}
        </BaseButton>
      }
      isLoadingConfirm={isLoadingSubmit || isLoading}
      ref={modalRef}
      widthModal={900}
      renderContent={
        <BaseForm
          form={form}
          onFinish={handleSubmit}
          initialValues={initValuesFormCreateTum}
        >
          <FormTumCommon
            setEmail={setEmail}
            reset={reset}
            moreExtend={
              <BaseForm.Item
                name={'image'}
                valuePropName="file"
                required
                label={'Đơn gia nhập'}
                rules={[
                  {
                    required: true,
                    message: t(R.strings.require_field, {
                      field: 'Image',
                    }),
                  },
                ]}
              >
                <Dragger
                  name="file"
                  multiple={false}
                  onChange={handleUploadChange}
                  beforeUpload={() => false}
                  style={{
                    borderRadius: 10,
                    padding: '10px 20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    borderStyle: 'solid',
                  }}
                  showUploadList={false}
                >
                  <BaseRow
                    gutter={16}
                    align={'middle'}
                    justify={'space-between'}
                  >
                    {fileName ? (
                      <BaseCol xl={8}>
                        <BaseText
                          fontWeight="semibold"
                          colorText="collapseBackgroundColor"
                          children={fileName}
                        />
                      </BaseCol>
                    ) : null}
                    <BaseCol xl={14}>
                      <p>
                        Drag an files here,{' '}
                        <span style={{ color: '#1890ff' }}>upload</span>, or{' '}
                        <span style={{ color: '#1890ff' }}>
                          browse files library
                        </span>
                        .
                      </p>
                    </BaseCol>

                    <BaseCol xl={2}>
                      <SvgPictureIcon />
                    </BaseCol>
                  </BaseRow>
                </Dragger>
              </BaseForm.Item>
            }
          />

          {loading ? <Loading size="small" /> : null}
        </BaseForm>
      }
    />
  )
}
